<template>
  <v-container
    id="fondo"
    fluid
    style="height:100%"
    class="d-flex justify-center align-center fill-height"
  >
    <v-row align="center" justify="center">
      <v-col
        cols="12"
        sm="12"
        md="10"
        class="d-flex justify-center align-center"
      >
        <v-card class="elevation-24" min-width="340">
          <v-card-title
            class="white--text primary font-weight-bold  text-center mx-auto text-uppercase"
            >{{ $t("emailVerified.v-card-title") }}</v-card-title
          >
          <v-card-text
            class="my-12 col-12 d-flex justify-center text-center align-center"
            >{{ $t("emailVerified.v-card-text") }}</v-card-text
          >
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {};
</script>

<style></style>
